import { openChannelDestination } from '../resolve-channels';
import type { ChannelOpenContext, ChannelWidgetAdapter } from './types';
import type { WidgetChannel } from '../types';

function createLinkAdapter(type: WidgetChannel['type']): ChannelWidgetAdapter {
  return {
    type,
    canHandle(channel) {
      return channel.type === type && Boolean(channel.destination);
    },
    open(channel) {
      if (channel.destination) {
        openChannelDestination(channel.destination);
      }
    },
  };
}

const telegramAdapter = createLinkAdapter('telegram');
const whatsappAdapter = createLinkAdapter('whatsapp');
const messengerAdapter = createLinkAdapter('messenger');
const instagramAdapter = createLinkAdapter('instagram');

const webchatAdapter: ChannelWidgetAdapter = {
  type: 'webchat',
  canHandle(channel) {
    return channel.type === 'webchat';
  },
  open(channel, context: ChannelOpenContext) {
    context.openWebChat(channel);
  },
};

const adapters: ChannelWidgetAdapter[] = [
  telegramAdapter,
  whatsappAdapter,
  messengerAdapter,
  instagramAdapter,
  webchatAdapter,
];

export function getChannelAdapter(
  channel: WidgetChannel,
): ChannelWidgetAdapter | null {
  return adapters.find((adapter) => adapter.canHandle(channel)) ?? null;
}

export function openWidgetChannel(
  channel: WidgetChannel,
  context: ChannelOpenContext,
): void {
  const adapter = getChannelAdapter(channel);
  adapter?.open(channel, context);
}
